export function numberWithSpaces(x: number | undefined) {
    return x?.toLocaleString()
            .replaceAll('.', ' ')
            .replaceAll(',', ' ')
        ?? '';
}